import React,{useState} from 'react';
import { Row, Col } from 'antd';
import DetailItem from "../../../../CSIComponents/DetailItem";
import Collapse, {Panel} from '../../../../ui/Collapse';
import { EnvironmentalImpact } from '../WaterUsageInterface/WaterUsageInterface';
import { useEffect } from 'react';



interface propsTypes {
  dataList: EnvironmentalImpact
}

const GeneralView = (props: propsTypes) => {
  const translateToYesOrNo = (data: string) => data === 'true' ? 'Yes' : (data === 'false' ? 'No' : '')
  
  const [descriptions, setDescriptions] = useState<Array<{desc?:string}>>()
  const data = props?.dataList?.environmentalimpact?.waterusage;

  useEffect(()=>{
    const description = props?.dataList?.environmentalimpact?.waterusage?.description;
    setDescriptions(!!description?.length?description: [{desc:''}])
  },[props?.dataList?.environmentalimpact?.waterusage?.description])

  const inputList = [
    { label: 'Gray Water Recycling', name: translateToYesOrNo(data?.greywaterecycling || '') },
    { label: 'Water Conservation', name: translateToYesOrNo(data?.waterconservation || '') },
    { label: 'Waste Diversion(%)', name: data?.waterdiversion },
    {},
    { label: 'Unit of Measure', name: data?.uom },
    { label: 'Per Room Night Time Period', name: data?.perroomnightperiod },
    { label: 'Per Room Day Time Period', name: data?.perroomdayperiod },
    {},
    { label: 'Waste Diversion Rate Time Period', name: data?.waterdiversionrateperiod },
    { label: 'Per Room Night', name: data?.perroomnight },
    { label: 'Per Room Day', name: data?.perroomday },
  ]
  return (
    <>
      <Row gutter={24}>
        {
          inputList.map((item, i) => {
            return (
              item.label
                ? <Col style={{ marginBottom: '30px' }} span={6} key={i}>
                  <DetailItem value={item.name} label={item.label} />
                </Col>
                : <Col span={5} key={i}></Col>
            )
          })
        }
      </Row>
      <Collapse defaultActiveKey={'0'} multiCollapseButton>
          {descriptions && descriptions.map((item: { desc?: string}, i: number) => {
            return (
              <Panel header={`Water Usage Program ${i + 1}`} key={i} style={{ marginBottom: '20px' }}>
                <Row gutter={24}>
                  <Col span={6}>
                    <DetailItem value={item.desc} label='Description' />
                  </Col>
                </Row>
              </Panel>
            )
          })}
        </Collapse>
    </>
  )
}


export default GeneralView;
